import {RouteObject} from 'react-router';
import {ROUTES} from '../routes';
import {ProtectedRoute} from '../auth/require-authorization';
import {CodeListing} from './code-listing';
import {CodeCreate, CodeUpdate} from './code-create-update';

export const CodeRoutes: RouteObject = {
  path: ROUTES.ADMIN.CODES.path,
  element: <ProtectedRoute role={'Global Admin'} />,
  children: [
    {
      path: ROUTES.ADMIN.CODES.INDEX.path,
      element: <CodeListing />,
    },
    {
      path: ROUTES.ADMIN.CODES.CREATE.path,
      element: <CodeCreate />,
    },
    {
      path: ROUTES.ADMIN.CODES.DETAIL.path,
      element: <CodeUpdate />,
    },
  ],
};
